const getTagObjects = (uploadIdsWithTags, isApproved = false) => {
    // no uploads to work with
    if (!uploadIdsWithTags || uploadIdsWithTags.length === 0) return [];

    // Grab First Upload in Array
    const firstUpload = uploadIdsWithTags[0];

    // single selection, no need to cross reference
    if (uploadIdsWithTags.length === 1) {
        return firstUpload.modTags.filter(to => to.isApproved === isApproved);
    }

    // If more than one, we only show shared tags across all selected uploads
    let commonTagObjects = [];

    // use first upload as template, if any of it's tags are in all the other uploads - add to commonTagObjects
    firstUpload.modTags.forEach(tagObj => {
        const thisTagName = tagObj.name;
        let isSharedByAll = true;
        uploadIdsWithTags.forEach(uwt => {
            const hasTagName = uwt.modTags.find(to => {
                return to.name === thisTagName;
            });
            if (!hasTagName) {
                isSharedByAll = false;
            }
        });

        if (isSharedByAll) {
            commonTagObjects.push(tagObj);
        }
    });

    // filter further by isApproved
    return commonTagObjects.filter(cto => cto.isApproved === isApproved);
};

export const getPendingAndApprovedTags = selectedUploads => {
    const pendingTags = getTagObjects(selectedUploads, false);
    const approvedTags = getTagObjects(selectedUploads, true);
    return { pendingTags, approvedTags };
};
